import { createSelector } from '@reduxjs/toolkit'

import { selectState } from '../selectState'

export const selectDownload = createSelector(selectState, (state) => state.download)
